import { Flex } from '@lucidhq/lucidium';

import { Layout, UnauthorizedMessage } from '@/components';

export const UnauthorizedPage = () => (
  <Layout size="medium">
    <Flex
      lss={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
      }}
    >
      <UnauthorizedMessage description="You are not authorized to view this page." />
    </Flex>
  </Layout>
);
